import React from 'react'
import Link from 'next/link'
import { motion } from 'framer-motion'
import { socialsArray } from '../../assets/svg/allSVG'
import logoFullColor from '../../assets/logos/SelongBelanakLogoFull.jsx'
import fullLogo from '../../public/brand/selong-belanak-wordmark-light.png'

import { base } from '../../styles/base/_allBase.styles'
const { StyleP } = base

import {
  BottomFooterDiv,
  FlexRow,
  FlexColumn,
  SocialContainer,
  LogoContainer,
  LogoWrapper,
  ImgFullLogo,
} from './footer.styles.jsx'

// Derive an accessible label for an icon-only social link from its URL.
const socialLabel = (url = '') => {
  const u = url.toLowerCase()
  if (u.includes('instagram')) return 'Selong Belanak on Instagram'
  if (u.includes('tripadvisor')) return 'Selong Belanak on Tripadvisor'
  if (u.includes('facebook')) return 'Selong Belanak on Facebook'
  if (u.includes('youtube')) return 'Selong Belanak on YouTube'
  return 'Selong Belanak social media'
}

const Footer = () => {
  const year = new Date().getFullYear()

  return (
    <BottomFooterDiv as={motion.footer}>
      <FlexRow>
        <FlexColumn>
          <ImgFullLogo
            alt={'Selong Belanak'}
            unoptimized
            src={fullLogo}
          />
        </FlexColumn>

        <FlexColumn>
          <StyleP style={{fontWeight:700}} color="white">Explore</StyleP>
          <Link href="/where-to-stay" passHref>
            <StyleP color={'white'}>Where to Stay</StyleP>
          </Link>
          <Link href="/eat-drink" passHref>
            <StyleP color="white">Eat &amp; Drink</StyleP>
          </Link>
          <Link href="/beaches-surfing" passHref>
            <StyleP color="white">Beaches &amp; Surfing</StyleP>
          </Link>
          <Link href="/surf-forecast" data-analytics-cta-id="footer:surf-forecast" data-analytics-placement-id="footer-explore"><StyleP color="white">Surf Forecast</StyleP></Link>
          <Link href="/things-to-do" passHref>
            <StyleP color="white">Things to Do</StyleP>
          </Link>
          <Link href="/getting-around" passHref>
            <StyleP color="white">Getting Around</StyleP>
          </Link>
        </FlexColumn>

        <FlexColumn>
          <StyleP style={{fontWeight:700}} color="white">Plan your visit</StyleP>
          <Link href="/getting-to-selong-belanak"><StyleP color="white">Getting here</StyleP></Link>
          <Link href="/getting-around"><StyleP color="white">Getting around</StyleP></Link>
          <Link href="/blog/best-time-to-visit-selong-belanak"><StyleP color="white">Best time to visit</StyleP></Link>
          <Link href="/travel-tips"><StyleP color="white">Travel tips</StyleP></Link>
          <Link href="/blog"><StyleP color="white">Travel guides</StyleP></Link>
          <Link href="/explore"><StyleP color="white">Places directory</StyleP></Link>
        </FlexColumn>
        <FlexColumn>
          <StyleP style={{fontWeight:700}} color="white">Help</StyleP>
          <Link href="/contact" passHref>
            <StyleP color="white">Contact</StyleP>
          </Link>
          <Link href="/about" passHref>
            <StyleP color="white">About This Guide</StyleP>
          </Link>
          <Link href="/sbca" passHref>
            <StyleP color="white">Community &amp; SBCA</StyleP>
          </Link>
          <Link href="/editorial-policy" passHref>
            <StyleP color="white">Editorial Policy</StyleP>
          </Link>
          <Link href="/api/sitemap.xml" style={{ textDecoration: 'none' }}>
            <StyleP color="white">Sitemap</StyleP>
          </Link>
          <Link href="/privacy-policy" passHref>
            <StyleP color="white">Privacy Policy</StyleP>
          </Link>
        </FlexColumn>

        <FlexColumn>
          <StyleP style={{fontWeight:700}} color="white">Follow Us</StyleP>
          <SocialContainer>
            {socialsArray.map(({ Icon, url }, idx) => (
              <motion.div
                key={idx}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <Link
                  href={url}
                  passHref
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={socialLabel(url)}
                >
                  <LogoContainer>
                    <Icon />
                  </LogoContainer>
                </Link>
              </motion.div>
            ))}
          </SocialContainer>
        </FlexColumn>
      </FlexRow>

      <FlexRow
        style={{
          justifyContent: 'space-between',
          width: '100%',
          marginTop: '2rem',
        }}
      >
        <StyleP color="white">© {year} Selong-Belanak.com</StyleP>
        <StyleP color="white">Crafted by YTS</StyleP>
      </FlexRow>
    </BottomFooterDiv>
  )
}

export default Footer
export { Footer }
